import { createFileRoute } from "@tanstack/react-router";
import { QaPage, qaJsonLd } from "@/components/QaPage";
import { breadcrumbJsonLd } from "@/lib/seo-jsonld";
import { LAST_REVIEWED } from "@/lib/official-sources";

const QUESTION = "Vad är pausservering och vem kan få det?";
const SHORT_ANSWER = "Pausservering är ett tillstånd att servera vin, öl och andra jästa drycker i foajé under paus på teater eller konsert.";

export const Route = createFileRoute("/fraga/kan-jag-anvanda-pausservering")({
  component: () => (
    <QaPage
      breadcrumbs={[
        { label: "Hem", to: "/" },
        { label: "Frågor & svar", to: "/fraga" },
        { label: "Vad är pausservering och vem kan få det" },
      ]}
      question={QUESTION}
      shortAnswer={SHORT_ANSWER}
      body={"Pausservering regleras i 8 kap. 4 § alkohollagen och kräver tillstånd från kommunen. Servering av spritdrycker är inte tillåten. Främst aktuellt för teatrar, konserthus, operahus och liknande etablerade kulturarrangörer."}
      source={{ label: "Alkohollagen (2010:1622) – Riksdagen", href: "https://www.riksdagen.se/sv/dokument-och-lagar/dokument/svensk-forfattningssamling/alkohollag-20101622_sfs-2010-1622/" }}
      extraSources={[]}
      deepGuide={{ to: "/serveringstillstand", label: "Serveringstillstånd – fullständig guide" }}
      related={[{"to": "/fraga/vad-ar-gemensam-serveringsyta", "label": "Vad är en gemensam serveringsyta?"}, {"to": "/fraga/far-jag-ha-uteservering", "label": "Får jag ha uteservering med serveringstillstånd?"}, {"to": "/fraga/cateringtillstand-vad-innebar-det", "label": "Vad innebär ett cateringtillstånd?"}]}
      lastReviewed={LAST_REVIEWED}
    />
  ),
  head: () => ({
    meta: [
      { title: "Vad är pausservering och vem kan få det?" },
      { name: "description", content: "Pausservering är ett tillstånd att servera vin, öl och andra jästa drycker i foajé under paus på teater eller konsert." },
      { property: "og:title", content: QUESTION },
      { property: "og:description", content: SHORT_ANSWER },
      { property: "og:url", content: "https://alkoholprovet.se/fraga/kan-jag-anvanda-pausservering" },
    ],
    links: [{ rel: "canonical", href: "https://alkoholprovet.se/fraga/kan-jag-anvanda-pausservering" }],
    scripts: [
      qaJsonLd({
        url: "https://alkoholprovet.se/fraga/kan-jag-anvanda-pausservering",
        question: QUESTION,
        answer: SHORT_ANSWER,
      }),
      breadcrumbJsonLd([
        { label: "Hem", url: "https://alkoholprovet.se/" },
        { label: "Frågor & svar", url: "https://alkoholprovet.se/fraga" },
        { label: "Vad är pausservering och vem kan få det", url: "https://alkoholprovet.se/fraga/kan-jag-anvanda-pausservering" },
      ]),
    ],
  }),
});
